import { useAccess } from '@umijs/max';
import React from 'react';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  permission_code?: string;
  permissionCode?: string;
};

const AuthLink: React.FC<Props> = ({ permission_code, permissionCode, ...props }) => {
  const access = useAccess();
  const code = permissionCode ?? permission_code;
  const allowed = !code || access?.hasPermission?.(code);
  if (!allowed) return null;

  if (code) {
    return <a {...props} data-permission-code={code} />;
  }
  return <a {...props} />;
};

export default AuthLink;
